/**
 * @generated SignedSource<<5f4f2e818adbb3faff940b9ff1430dbd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentCost_agent$data = {
  readonly fees: {
    readonly feesIncludeVat: boolean | null | undefined;
    readonly inventory: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
    readonly letOnly: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
    readonly management: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
    readonly managementWithTenantInPlace: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
    readonly otherFees: ReadonlyArray<{
      readonly amountPence: number | null | undefined;
      readonly label: string | null | undefined;
      readonly percent: string | null | undefined;
    }> | null | undefined;
    readonly renewal: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
    readonly rentCollection: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
    readonly rentCollectionWithTenantInPlace: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
    readonly tenantFind: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly name: string | null | undefined;
  readonly primaryArea: {
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
    readonly stats: {
      readonly management: {
        readonly maximumPercentIncVat: number | null | undefined;
        readonly medianPercentIncVat: number | null | undefined;
        readonly minimumPercentIncVat: number | null | undefined;
        readonly percentsIncVat: ReadonlyArray<number> | null | undefined;
        readonly sampleSize: number | null | undefined;
      } | null | undefined;
      readonly rentCollection: {
        readonly maximumPercentIncVat: number | null | undefined;
        readonly medianPercentIncVat: number | null | undefined;
        readonly minimumPercentIncVat: number | null | undefined;
        readonly percentsIncVat: ReadonlyArray<number> | null | undefined;
        readonly sampleSize: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "DirectoryAgentCost_agent";
};
export type DirectoryAgentCost_agent$key = {
  readonly " $data"?: DirectoryAgentCost_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentCost_agent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "percent",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountPence",
  "storageKey": null
},
v3 = [
  (v1/*:: as any*/),
  (v2/*:: as any*/)
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sampleSize",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minimumPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "medianPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "maximumPercentIncVat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentsIncVat",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectoryAgentCost_agent",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentFees",
      "kind": "LinkedField",
      "name": "fees",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feesIncludeVat",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "management",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "rentCollection",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "tenantFind",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "letOnly",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "renewal",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "inventory",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "managementWithTenantInPlace",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "rentCollectionWithTenantInPlace",
          "plural": false,
          "selections": (v3/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentOtherFee",
          "kind": "LinkedField",
          "name": "otherFees",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            (v1/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryArea",
      "kind": "LinkedField",
      "name": "primaryArea",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAreaStats",
          "kind": "LinkedField",
          "name": "stats",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LandlordDirectoryAreaPercentFeeStats",
              "kind": "LinkedField",
              "name": "management",
              "plural": false,
              "selections": (v4/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LandlordDirectoryAreaPercentFeeStats",
              "kind": "LinkedField",
              "name": "rentCollection",
              "plural": false,
              "selections": (v4/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LandlordDirectoryAgent",
  "abstractKey": null
};
})();

(node as any).hash = "2936cfbebbfb59395b365800110e22c0";

export default node;
